"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListItemSearch = void 0;
var React = require("react");
var _Core_1 = require("../../_Core");
var Icons_1 = require("../../Icons");
var Localization_1 = require("../../Localization");
var Searcher_1 = require("../../Searcher");
var DropList_styles_1 = require("./DropList.styles");
var DropListItemSearch = function (_a) {
    var SearchAriaLabel = _a.SearchAriaLabel, OnSearch = _a.OnSearch, OnSearchCancel = _a.OnSearchCancel;
    var searcher = Searcher_1.useSearcher(OnSearch, OnSearchCancel, { TriggerCancelOnEmptyString: true });
    var handleSearchButtonClicked = function (e) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (searcher.hasSearchValue) {
            searcher.triggerCancel();
        }
    };
    var handleSearchOnKeyPressed = function (e) {
        e.stopPropagation();
        searcher.inputProps.onKeyUp(e);
    };
    return (React.createElement(DropList_styles_1.SearchWrapperDiv, null,
        React.createElement(DropList_styles_1.SearchInput, __assign({ onClick: function (e) { return e.stopPropagation(); }, "aria-label": Boolean(SearchAriaLabel) ? SearchAriaLabel : Localization_1.strings.Searcher_Label_Search, placeholder: Localization_1.strings.Searcher_Label_Search }, searcher.inputProps, { onKeyUp: handleSearchOnKeyPressed })),
        React.createElement(DropList_styles_1.SearchButton, { "aria-label": Localization_1.strings.Searcher_Label_ClearSearch, disabled: !searcher.hasSearchValue, onClick: handleSearchButtonClicked },
            React.createElement(Icons_1.Icon, { Icon: searcher.hasSearchValue ? _Core_1.Icons.CloseThick : _Core_1.Icons.Search }))));
};
exports.DropListItemSearch = DropListItemSearch;
